$("body").on("click", ".open-cron-menu", function () {
    var $this = $(this);
    var menu = $this.parents(".cron-menu-wrapper");

    $(".cron-menu", menu).css({
        top: menu.position().top,
        left:
            5 + (menu.position().left + menu.width()) - $(".cron-menu", menu).width()
    });

    menu.addClass("opened");
    closeDropdown($this.parents(".cron-menu-wrapper").attr("data-dropdown"));
    return false;
});

$('body').on('click', '.edit-cron-trigger', function() {
    var data = $(this).parents('.cron');
    $('.edit-cron form').attr('action', $('.edit-cron form').attr('data-action')+data.attr('data-cron'));

	$('.edit-cron input[name="interval"]').val(data.attr('data-interval'));
    $('.edit-cron input[name="cron_date"]').val(data.attr('data-cron_date_raw'));
    $('.edit-cron [name="job_details"]').val(data.attr("data-job_details"));
    $('.edit-cron input[name="processed"]').prop('checked', data.attr('data-processed') === 'true' ? true : false);
    $('.edit-cron input[name="recurring"]').prop('checked', data.attr('data-recurring') === 'true' ? true : false);
    
    closeDropdown();
    openModal('.edit-cron');
    return false;
});

$('body').on('submit', '.edit-cron form', function() {
    var $this = $(this);
    var modal = $this.parents('.modal');
    var fields = $this.serializeArray();
    fields[fields.length] = { name: '_token', value: $('meta[name="csrf-token"]').attr('content') };
    
    var error = false;

    modal.find('.required').each(function() {
        if($(this).val() === '') {
            error = true;
        }
    });

    if(error) {
        showError('Error', 'Please fill out all required fields');
        return false;
    }
    
    loading();
    $.ajax({
        type : 'POST',
        url : $this.attr('action'),
        data : fields,
        dataType : 'json',
        success : function(data) {
            // console.log(data);
            unloading();

            if(!data.success) {
                showError('Error', data.message);
                return false;
            }

            closeModal();
            addNotification(data.notification.title, data.notification.message, data.notification.icon);
        },
        error : function(request) {
            console.log(request.responseText);
        }
    });

    return false;
});


channel.bind('process-cron', function(data) {
    // console.log(data);
    var element;

    if($('.cron[data-cron="'+data.cron+'"]').length) {
        element = $('.cron[data-cron="'+data.cron+'"]');
        element.attr('data-interval', data.interval);
        element.attr('data-processed', data.processed);
        element.attr('data-recurring', data.recurring);
        element.attr('data-cron_date_raw', data.cron_date_raw);
		
        element.find('[data-input="job"]').html(data.job);
        element.find('[data-input="interval"]').html(data.interval);
        element.find('[data-input="processed_text"]').html(data.processed_text);
        element.find('[data-input="recurring_text"]').html(data.recurring_text);
        element.find('[data-input="cron_date"]').html(data.cron_date);
        element.find('[data-input="date_added"]').html(data.date_added);
        element.find('.cron-menu').html(buttons(data.buttons));
        return;
    }
});